import './EditorPreview.css';

import { Markdown } from '@tiptap/markdown';
import { EditorContent,useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

interface EditorPreviewProps {
	value: string;
	open?: boolean;
}

const EditorPreview = ({ value, open }: EditorPreviewProps) => {
	const editor = useEditor({
		extensions: [StarterKit, Markdown],
		content: value || '',
		editable: false,
		contentType: 'markdown',
	});

	const classNameEditor = open
		? ['editor-preview', 'editor-global', 'editor-preview--open'].join(' ')
		: ['editor-preview', 'editor-global'].join(' ');

	return (
		<div className={classNameEditor}>
			<EditorContent editor={editor} />
		</div>
	);
};

export default EditorPreview;
